import { Column } from "@/shared/components/table/table.model";
import { ClusterElementFragment } from "@/core/graphql/graphql";
import { extractProperty } from "@/utils/extract-property";

export const ELEMENTS_COLUMNS: Column<ClusterElementFragment>[] = [
  {
    columnId: 'id',
    caption: 'ID',
    fieldSelector: (element) => extractProperty(element.id),
  },
  {
    columnId: 'owner',
    caption: 'Owner',
    fieldSelector: (element) => extractProperty(element.owner?.username),
  },
  {
    columnId: 'type',
    caption: 'Type',
    fieldSelector: (element) => extractProperty(element.type),
  },
  {
    columnId: 'text',
    caption: 'Text',
    fieldSelector: (element) => element.text ? extractProperty(element.text) : 'Not Provided',
  },
];
